import useToastStore from '@stores/useToastStore';

const useToast = () => {
  const { addToastList: showToast, clearAllToastList: hideAllToast } =
    useToastStore((state) => state);

  return { showToast, hideAllToast };
};

export default useToast;
